import * as $http from 'axios'

export default {
    initSchedule: payload => $http.post(`v2/schedules`, payload),
    createSchedule: payload => $http.post(`v2/schedules`, payload),
    addReservation: payload => $http.put('v2/schedules/add_reservation', payload),
}
